<template>
    <span>
        <h5 v-if="label">
            {{ label | capitalize }}<br>
        </h5>

        <my-checkbox
            ref="my_checkbox"
            v-model="current_value"
            :options="items ? items : [item]"
            :label="label"
            :name="name"
            :clearable="clearable"
            :allow-empty="allowEmpty"
            :multiple="multiple"
            track-by="id"
            @input="valueUpdated"
        />
    </span>
</template>

<script>
export default {
    props: {
        allowEmpty: {
            type: Boolean,
            default: true,
        },

        clearable: {
            type: Boolean,
            required: false,
        },

        item: {
            type: Object,
            required: false,
        },

        items: {
            type: Array,
            required: false,
        },

        label: {
            type: String,
            required: false,
        },

        multiple: {
            type: Boolean,
            required: false,
        },

        name: {
            type: String,
            required: false,
        },

        value: {
            type: String | Number,
            required: false,
        }
    },

    data() {
        return {
            current_value: this.value
        }
    },

    methods: {
        valueUpdated() {
            this.$emit('input', this.current_value)
            this.$emit('updated')
        },

         clearInput() {
            this.$refs.my_checkbox.clearInput();
        },
    }
}
</script>